import { memo } from 'react';
import { productIcon } from './icons';

/**
 * Products — "What I Offer / Products & Services" icon-card grid built from the
 * agent's plans. Collapses when no plans are set.
 */
export const Products = memo(({ plans = [] }) => {
  if (!plans.length) return null;

  return (
    <section className="cw-section section-products" id="products">
      <div className="cw-container">
        <header className="section-head reveal">
          <p className="section-eyebrow">What I Offer</p>
          <h2 className="section-title">Products &amp; Services</h2>
          <span className="section-bar" aria-hidden="true" />
        </header>
        <ul className="product-grid reveal">
          {plans.map((plan, i) => {
            const Icon = productIcon(plan);
            return (
              <li className="product-card" key={`${plan}-${i}`}>
                <span className="product-icon">
                  <Icon />
                </span>
                <span className="product-name">{plan}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
});
